<template>
  <div class="my_background_layer">
    <my_radio
      :titleWidth="titleWidth"
      :title="title || $t('widgets_basic_button_edit_444')"
      :option="option"
      :defaultIsShow="defaultIsShow"
      :hiddenIsShow="hiddenIsShow"
      :selfIsShow="selfIsShow"
      :defaultIsDisabled="defaultIsDisabled"
      :hiddenIsDisabled="hiddenIsDisabled"
      :selfIsDisabled="selfIsDisabled"
      :selectValue.sync="radio_value"
    >
      <div slot="pull_down_control">
        <my_select
          :titleWidth="titleWidth"
          :title="bgTypeTitle"
          :options="backgroundTypeOption"
          :value.sync="bg_type"
          v-if="bg_type !== undefined"
        ></my_select>
        <span v-if="bg_type == 'default' && img_url !== undefined ">
          <my_img_button
            :titleWidth="titleWidth"
            :title="uploadTitle"
            @uploadImg="uploadImg"
            :imgUrl.sync="img_url"
          ></my_img_button>
        </span>
        <my_icon_select
          :titleWidth="titleWidth"
          keyType="img_scale"
          :title="imgScaleTitle"
          :value.sync="img_scale"
          :options="imgScaleOption"
          v-if="img_scale !==undefined
           && bg_type !== undefined
           && img_url !== ''
           && bg_type == 'default'"
           @imgScaleChange="imgScaleChange"
        ></my_icon_select>
        <my_icon_select
          keyType="tile_effect"
          :titleWidth="titleWidth"
          :title="tileEffectTitle"
          :value.sync="tile_effect"
          :options="tileEffectOption"
          v-if="tile_effect !== undefined
          && img_scale !== undefined
          && img_url !== ''
          && bg_type == 'default'
          && img_scale == 'scale_tiling'"
          @tileEffectChange="tileEffectChange"
        ></my_icon_select>
        <my_img_pos
          :titleWidth="titleWidth"
          :title="imgPosTitle"
          :value.sync="img_pos"
          v-if="img_pos !== undefined
          && img_scale !== undefined
          && img_url !== ''
          && bg_type == 'default'
          && img_scale == 'scale_original_image'"
        ></my_img_pos>
        <template v-if="!hasSeColor">
          <my_color
            :titleWidth="titleWidth"
            :title="colorTitle"
            :color.sync="color_value"
            v-if="color_value !==undefined"
            :linear_gradient.sync="my_linear_gradient"
            :pattern.sync="my_pattern"
          ></my_color>
        </template>
        
        <div class="has-select-color" v-else>
          <span class="title" :style="{width:titleWidth+'px'}">{{$t('view_back_top_edit_99')}}</span>
          <my_color
            class="color-picker"
            :title="$t('view_back_top_edit_103')"
            :color.sync="color_value"
            :linear_gradient.sync="my_linear_gradient"
            :pattern.sync="my_pattern"
          ></my_color>
          <my_color
            class="color-picker"
            :title="$t('base_options_config_1838')"
            :color.sync="se_color_value"
          ></my_color>
        </div>
        
        <!-- 产品背景色 这边 要多写一个 背景色 产品展示的背景色 选中颜色的时候 要有一个默认颜色 和悬浮颜色 所以这边要改一个东西 -->
      </div>
    </my_radio>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "my_background_index",
  props: {
    titleWidth: {
      type: String,
      default: "40"
    },
    type: {
      // 组件的标题
      type: String,
      default: "two_level"
    },
    title: {
      // 组件的标题
      type: String,
      default: ''
    },
    bgTypeTitle: {
      type: String,
      default: i18n.t('view_form_dialog_add_form_item_187')
    },
    imgScaleTitle: {
      type: String,
      default: i18n.t('widgets_basic_article_list_edit_380')
    },
    tileEffectTitle: {
      type: String,
      default: i18n.t('components_my_background_index_2293')
    },
    imgPosTitle: {
      type: String,
      default: i18n.t('components_my_background_index_2294')
    },
    uploadTitle: {
      type: String,
      default: i18n.t('view_back_top_edit_96')
    },
    colorTitle: {
      // 组件的标题
      type: String,
      default: i18n.t('view_back_top_edit_99')
    },
    radioValue: {
      type: String
    },
    bgType: {},
    colorValue: {
      type: String
    },
    option: {
      type: Array,
      default: function() {
        return [];
      }
    },
    backgroundTypeOption: {
      type: Array,
      default: function() {
        return this.$store.state.options.backgroundType;
      }
    },
    defaultIsShow: {
      type: String,
      default: "true"
    },
    hiddenIsShow: {
      type: String,
      default: "true"
    },
    selfIsShow: {
      type: String,
      default: "true"
    },
    defaultIsDisabled: {
      // 默认设置是否禁用
      type: String,
      default: "false"
    },
    hiddenIsDisabled: {
      // 隐藏设置是否禁用
      type: String,
      default: "false"
    },
    selfIsDisabled: {
      // 自定义设置是否禁用
      type: String,
      default: "false"
    },
    imgUrl: {
      type: String
    },
    imgScale: {
      // 图片缩放
      type: String
    },
    tileEffect: {
      type: String
    },
    imgPos: {
      type: String
    },
    imgScaleOption: {
      type: Array,
      default: function() {
        return this.$store.state.options.imgScaleList;
      }
    },
    tileEffectOption: {
      type: Array,
      default: function() {
        return this.$store.state.options.tileEffectList;
      }
    },
    pattern:{
      type: String,
      default: ""
    },
    linear_gradient:{
      type:Object,
      default:function() {
        return {};
      }
    },
    hasSeColor: { // 是否存在悬浮样式  产品展示 这边背景新增了一个悬浮样式
      type:Boolean,
      default: false
    },
    seColorValue: {
      type: String
    }
  },
  watch: {
    radio_value(val) {
      // 数据双向绑定
      this.$emit("update:radioValue", val);
    },
    bg_type(val) {
      // 数据双向绑定
      if (val === 'color') {
        this.img_url = ''
      } else {
        this.img_url = this.imgUrlTemp
      }
      this.$emit("update:bgType", val);
    },
    color_value(val) {
      // 数据双向绑定
      this.$emit("update:colorValue", val);
    },
    img_url(val) {
      this.$emit("update:imgUrl", val);
    },
    img_scale(val) {
      this.$emit("update:imgScale", val);
    },
    tile_effect(val) {
      this.$emit("update:tileEffect", val);
    },
    img_pos(val) {
      this.$emit("update:imgPos", val);
    },
    radioValue(val) {
      // 数据双向绑定
      this.radio_value = val;
    },
    bgType(val) {
      // 数据双向绑定
      this.bg_type = val;
    },
    colorValue(val) {
      // 数据双向绑定
      this.color_value = val;
    },
    imgUrl(val) {
      // 数据双向绑定
      this.img_url = val;
    },
    imgScale(val) {
      // 数据双向绑定
      this.img_scale = val;
    },
    tileEffect(val) {
      // 数据双向绑定
      this.tile_effect = val;
    },
    imgPos(val) {
      // 数据双向绑定
      this.img_pos = val;
    },
    pattern(val) {
      // 数据双向绑定
      this.my_pattern = val;
    },
    my_pattern(val){
      this.$emit("update:pattern", val);
    },
    linear_gradient(val){
      this.my_linear_gradient = val;
    },
    my_linear_gradient: {
      handler (val) {
        this.$emit("update:linear_gradient", val);
      },
      deep: true
    },
    se_color_value(val) { // 悬浮颜色
      this.$emit("update:seColorValue", val);
    },
    seColorValue(val) { // 悬浮的颜色
      this.se_color_value = val;
    },
  },
  data() {
    return {
      radio_value: this.radioValue,
      bg_type: this.bgType,
      color_value: this.colorValue,
      img_url: this.imgUrl,
      imgUrlTemp: this.imgUrl,
      img_scale: this.imgScale,
      tile_effect: this.tileEffect,
      img_pos: this.imgPos,
      my_pattern:this.pattern,
      my_linear_gradient:this.linear_gradient,
      se_color_value: this.seColorValue
    };
  },
  methods: {
    imgScaleChange(val) {
      this.$emit("imgScaleChange", val);
    },
    tileEffectChange(val) {
      this.$emit("tileEffectChange", val);
    },
    uploadImg() {
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileType", 1);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e instanceof Array && e.length > 0) {
          this.img_url = e[0].filePath;
          this.imgUrlTemp = e[0].filePath
        }

        this.$store.state.image_upload.imgFile = null;
      };
    }
  }
};
</script>

<style scoped type="text/css" lang="scss">
.my_background_layer{
  .has-select-color{
    display: flex;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/my_background/index.vue